"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRoleFromApi = parseRoleFromApi;
const role_1 = require("../../../model/v1/role");
const timeZones_1 = __importDefault(require("../../../common/timeZones"));
function parseRoleFromApi(roleRes) {
    const required = {
        id: roleRes.id,
        name: roleRes.name,
        timezone: timeZones_1.default.ASIA_TOKYO // hardcoded the Timezone here for now
    };
    const options = {
        isRoleSection: roleRes.isRoleSection,
        color: roleRes.color,
        slotType: roleRes.slotType,
        isGroupRole: roleRes.groupRole,
        isNightShift: roleRes.isNightShift,
        employees: roleRes.employees,
        isHiddenInShiftPage: roleRes.isHiddenInShiftPage,
        isDisabledWhenFull: roleRes.isDisabledWhenFull,
    };
    return new role_1.Role(required, options);
}
